export default {"id":"icon-icon-open-menu"}